import { PaginatedData } from "../../../hooks/PaginationHooks";
import { AuditLogItem } from "../../../types/auditLogTypes";
import { MainContentWrapper, TableWrapper } from "../../../components/common/Common.styles";
import AuditLogsTableHeader from "./AuditLogsTableHeader";
import { Box } from "@mui/material";
import AuditLogsTableRow from "./AuditLogsTableRow";
import { ServerSidePagination } from "../../../components/common/table/ServerSidePagination";

interface AuditLogsTableProps {
    data: PaginatedData<AuditLogItem>
}

export default function AuditLogsTable({data}: AuditLogsTableProps) {
    return (
        <MainContentWrapper sx={{ overflow: "hidden" }}>
            <Box sx={{overflowX: "auto", overflowY: "hidden" }}>
                <TableWrapper
                    columnsTemplate="1fr 1fr 1.25fr 1fr 0.5fr 1fr 1fr 1fr"
                    minWidth="1400px">
                    <AuditLogsTableHeader paginatedData={data} />

                    <Box sx={{ display: "contents" }}>
                        {data.items.map((item) => (<AuditLogsTableRow
                            key={item.timestamp}
                            item={item}
                        />))}
                    </Box>
                </TableWrapper>
            </Box>

            <Box sx={{ display: "flex", justifyContent: "flex-end" }}>
                <ServerSidePagination paginatedData={data} />
            </Box>
        </MainContentWrapper>
    );
};